import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api';

export default function Register() {
  const [form, setForm] = useState({
    agency_name: '',
    your_name: '',
    email: '',
    phone: '',
    password: '',
    password_confirmation: '',
  });
  const [error, setError] = useState('');
  const [fieldErrors, setFieldErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const set = (field) => (e) => setForm(f => ({ ...f, [field]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setFieldErrors({});
    setLoading(true);
    try {
      const res = await api.post('/register', form);
      const { token } = res.data;
      localStorage.setItem('leadex_token', token);
      // Full page reload so AuthContext picks up the new token
      window.location.href = '/dashboard';
    } catch (err) {
      if (err.response?.status === 422) {
        // Laravel validation errors — show per-field
        const errs = err.response.data.errors || {};
        setFieldErrors(errs);
        setError('Please fix the errors below.');
      } else {
        setError(err.response?.data?.message || 'Registration failed. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  const field = (label, name, type = 'text', placeholder = '') => (
    <div style={styles.formGroup}>
      <label style={styles.label}>{label}</label>
      <input
        type={type}
        value={form[name]}
        onChange={set(name)}
        style={{
          ...styles.input,
          ...(fieldErrors[name] ? { borderColor: '#ef4444' } : {}),
        }}
        placeholder={placeholder}
        required={name !== 'phone'}
      />
      {fieldErrors[name] && (
        <div style={styles.fieldError}>{fieldErrors[name][0]}</div>
      )}
    </div>
  );

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        {/* Brand */}
        <div style={styles.brand}>
          <div style={styles.logo}>L</div>
          <div>
            <div style={styles.brandName}>Leadex WorkOps</div>
            <div style={styles.brandTagline}>Digital Marketing Operations</div>
          </div>
        </div>

        <h2 style={styles.title}>Start your free 14-day trial</h2>
        <p style={styles.subtitle}>No credit card required. Full access from day one.</p>

        {error && <div style={styles.error}>{error}</div>}

        <form onSubmit={handleSubmit}>
          {field('Agency / Company Name', 'agency_name', 'text', 'e.g. One Hundred Technologies')}
          {field('Your Name', 'your_name', 'text', 'Your full name')}
          {field('Work Email', 'email', 'email', 'you@agency.com')}
          {field('Phone (optional)', 'phone', 'tel', '+91 98765 43210')}
          {field('Password', 'password', 'password', 'At least 8 characters')}
          {field('Confirm Password', 'password_confirmation', 'password', 'Repeat your password')}

          <button
            type="submit"
            style={loading ? { ...styles.button, opacity: 0.7 } : styles.button}
            disabled={loading}
          >
            {loading ? 'Creating your account...' : 'Create Account & Start Trial'}
          </button>
        </form>

        <div style={styles.loginLink}>
          Already have an account?{' '}
          <Link to="/login" style={styles.link}>Sign in</Link>
        </div>

        <div style={styles.terms}>
          By creating an account you agree to our{' '}
          <span style={styles.link}>Terms of Service</span> and{' '}
          <span style={styles.link}>Privacy Policy</span>.
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    background: '#0f1117',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
  },
  card: {
    background: '#1a1d27',
    borderRadius: '16px',
    padding: '40px',
    width: '100%',
    maxWidth: '440px',
    border: '1px solid #2a2d3e',
  },
  brand: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    marginBottom: '28px',
  },
  logo: {
    width: '44px',
    height: '44px',
    background: 'linear-gradient(135deg, #6c58f0, #4f8ef7)',
    borderRadius: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#fff',
    fontSize: '20px',
    fontWeight: '700',
    flexShrink: 0,
  },
  brandName: {
    color: '#fff',
    fontSize: '18px',
    fontWeight: '700',
  },
  brandTagline: {
    color: '#6b7280',
    fontSize: '12px',
  },
  title: {
    color: '#fff',
    fontSize: '22px',
    fontWeight: '600',
    marginBottom: '6px',
  },
  subtitle: {
    color: '#6b7280',
    fontSize: '13px',
    marginBottom: '24px',
  },
  error: {
    background: '#2d1515',
    border: '1px solid #ef4444',
    color: '#ef4444',
    padding: '12px',
    borderRadius: '8px',
    marginBottom: '16px',
    fontSize: '14px',
  },
  formGroup: {
    marginBottom: '14px',
  },
  label: {
    display: 'block',
    color: '#9ca3af',
    fontSize: '13px',
    marginBottom: '5px',
  },
  input: {
    width: '100%',
    padding: '11px 12px',
    background: '#0f1117',
    border: '1px solid #2a2d3e',
    borderRadius: '8px',
    color: '#fff',
    fontSize: '14px',
    boxSizing: 'border-box',
    outline: 'none',
  },
  fieldError: {
    color: '#ef4444',
    fontSize: '12px',
    marginTop: '4px',
  },
  button: {
    width: '100%',
    padding: '13px',
    background: 'linear-gradient(135deg, #6c58f0, #4f8ef7)',
    border: 'none',
    borderRadius: '8px',
    color: '#fff',
    fontSize: '15px',
    fontWeight: '600',
    cursor: 'pointer',
    marginTop: '8px',
  },
  loginLink: {
    textAlign: 'center',
    marginTop: '20px',
    color: '#6b7280',
    fontSize: '14px',
  },
  link: {
    color: '#6c58f0',
    cursor: 'pointer',
    textDecoration: 'none',
  },
  terms: {
    textAlign: 'center',
    marginTop: '12px',
    color: '#4b5563',
    fontSize: '11px',
    lineHeight: '1.5',
  },
};
